exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component='transfer-result'] {\n  padding: 0 0 30px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/rescue/rescue-result/rescue-result.component.styl
// module id = ../../../../../src/app/master/investments/rescue/rescue-result/rescue-result.component.styl
// module chunks = main